import { createEvent, sample } from 'effector';
import type { GeneralID } from '@types';
import {
  $categoryMap,
  $curCategoryId,
  $selectedPathApi,
} from '@stores/dataStores';

export const selectCategory = createEvent<number | null>();
sample({
  source: $categoryMap,
  clock: selectCategory,
  fn: (map, cId) => ({ map, cId }),
}).watch(({ map, cId }) => {
  if (cId === null) {
    $selectedPathApi.update(() => ({
      id: null,
      categoryPath: [],
    }));
  } else {
    const item = map.get(cId);
    if (!item) return;
    const sub = map.get(item.categoryIds[0]);
    if (sub) {
      $selectedPathApi.update(() => ({
        id: sub.sceneIds[0] || null,
        categoryPath: [cId, sub.id],
      }));
    } else {
      $selectedPathApi.update(() => ({
        id: item.sceneIds[0] || null,
        categoryPath: [cId],
      }));
    }
  }
});

export const selectSubCategory = createEvent<number | null>();
sample({
  source: { cid: $curCategoryId, map: $categoryMap },
  clock: selectSubCategory,
  fn: (source, subId) => ({ ...source, subId }),
}).watch(({ cid, map, subId }) => {
  if (subId === null) {
    $selectedPathApi.update(() => ({
      id: null,
      categoryPath: [cid],
    }));
  } else {
    const sub = map.get(subId);
    if (!sub) return;
    $selectedPathApi.update(() => ({
      id: sub.sceneIds[0] || null,
      categoryPath: [cid, subId],
    }));
  }
});

export const selectScene = createEvent<GeneralID | null>();
selectScene.watch((id) => {
  $selectedPathApi.update((draft) => {
    draft.id = id;
  });
});
